import { createReducer } from "../../../utils/redux/create-reducer";
import Types from "./types";
import { reset as resetRescheduleFlow } from "../../../utils/reschedule-flow";
import getNotServicibilityStatus from "../../../utils/helpers/get-not-servicibility-status";
import { APPOINTMENT_TYPE } from "../../../constants/app-constants";

export const INITIAL_STATE = {
    zone: null,
    locations: [],
    slots: null,
    homeInspection: null,
    branch: null,
    date: null,
    time: null,
    cityId: null,
    cityName: null,
    pincode: null,
    isLoading: true,
    apiResponse: {},
    isSlotsError: false,
    isOnlyHomeInspection: false,
    isNotServicible: false,
    selectedInspectionType: null,
    coords: {
        lat: 0,
        lng: 0
    },
    isAppointmentDetailsFetched: false,
    homeInspectionPremiumSlotAvailable: false,
    homeInspectionExpressSlotAvailable: false
};

export const fetchSlots = (state = INITIAL_STATE) => {
    return { ...state, isSlotsError: false, isLoading: true };
};

export const fetchSlotsSuccess = (state = INITIAL_STATE, { locations, zone, slots, homeInspectionPremiumSlotAvailable,
    homeInspectionExpressSlotAvailable }) => {
    let inspectionType = null;
    if (zone === null) {
        inspectionType = APPOINTMENT_TYPE.BRANCH;
    }
    return {
        ...state,
        zone,
        locations,
        slots,
        isLoading: false,
        isOnlyHomeInspection: zone && !locations.length,
        isNotServicible: getNotServicibilityStatus({ zone, locations, slots }),
        selectedInspectionType: inspectionType,
        isSlotsError: false,
        homeInspectionPremiumSlotAvailable,
        homeInspectionExpressSlotAvailable
    };
};

export const fetchSlotsFailure = (state = INITIAL_STATE) => {
    return { ...state, isSlotsError: true, isLoading: false, zone: null, locations: [], slots: null, branch: null };
};

export const fetchApptDataSuccess = (state = INITIAL_STATE,
    {
        branch,
        address,
        cityId,
        cityName,
        apiResponse,
        geoData
    }) => {
    let homeInspection = false;
    if (geoData && geoData.zone_id) {
        homeInspection = true;
    }
    return {
        ...state,
        homeInspection,
        cityId,
        cityName,
        branch: parseInt(branch),
        address,
        apiResponse: { ...apiResponse },
        coords: {
            lat: geoData.user_lat,
            lng: geoData.user_lng
        },
        pincode: apiResponse.pincode,
        isAppointmentDetailsFetched: true
    };
};

export const setBranch = (state = INITIAL_STATE, { id: branch }) => {
    return { ...state, branch,  ...resetRescheduleFlow("branch") };
};

export const setCity = (state = INITIAL_STATE, { cityId }) => {
    return { ...state, cityId };
};

export const setDate = (state = INITIAL_STATE, { date }) => {
    return { ...state, date, ...resetRescheduleFlow("date") };
};

export const setTime = (state = INITIAL_STATE, { time }) => {
    return { ...state, time, ...resetRescheduleFlow("time") };
};

export const resetResponseKey = (state = INITIAL_STATE) => {
    return { ...state, apiResponse: {} };
};

export const setSelectedInspectionType = (state = INITIAL_STATE, { selectedInspectionType }) => {
    return { ...state, selectedInspectionType };
};

export const updateCoordinates = (state = INITIAL_STATE, { coords }) => {
    return { ...state, coords };
};

export const HANDLERS = {
    [Types.FETCH_SLOTS_SUCCESS]: fetchSlotsSuccess,
    [Types.FETCH_SLOTS_FAILURE]: fetchSlotsFailure,
    [Types.FETCH_APPT_DATA_SUCCESS]: fetchApptDataSuccess,
    [Types.SET_BRANCH]: setBranch,
    [Types.SET_DATE]: setDate,
    [Types.SET_TIME]: setTime,
    [Types.RESET_RESPONSE_KEY]: resetResponseKey,
    [Types.SET_CITY]: setCity,
    [Types.SET_SELECTED_INSPECTION_TYPE]: setSelectedInspectionType,
    [Types.UPDATE_COORDINATES]: updateCoordinates,
    [Types.FETCH_SLOTS]: fetchSlots
};

export default createReducer(INITIAL_STATE, HANDLERS);
